import { render } from "./myPurchase.vue?vue&type=template&id=6a410e3e&scoped=true"
import script from "./myPurchase.vue?vue&type=script&lang=js"
export * from "./myPurchase.vue?vue&type=script&lang=js"

import "./myPurchase.vue?vue&type=style&index=0&id=6a410e3e&scoped=true&lang=less"
import "./myPurchase.vue?vue&type=style&index=1&id=6a410e3e&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a410e3e"]])

export default __exports__